import { T } from '@tribeplatform/react-components/i18n'
import { Divider } from '@tribeplatform/react-ui-kit/Divider'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { ChooseDomain } from './WizardStates/ChooseDomain.js'
import { TransferInProgress } from './WizardStates/TransferInProgress.js'

interface Props {
  canUseCustomDomain: boolean
  isRefetchingNetwork: boolean
  currentNominee?: string
}
export const TransferWizard = ({
  canUseCustomDomain,
  isRefetchingNetwork,
  currentNominee,
}: Props) => {
  const transferInProgress = !!currentNominee
  if (transferInProgress) {
    return (
      <div>
        <Divider>
          <Text
            variant="bodyLg"
            fontWeight="semibold"
            className="animate-pulse"
          >
            <T
              defaultMessage="Address transfer in progress"
              id="Admin.Domain.TransferInProgress"
            />
          </Text>
        </Divider>
        <TransferInProgress
          domain={currentNominee}
          isRefetchingNetwork={isRefetchingNetwork}
        />
      </div>
    )
  }

  return (
    <div>
      <Divider>
        <Text variant="bodyLg" fontWeight="semibold">
          <T
            defaultMessage="Want to use a different address for your site?"
            id="Admin.Domain.TransferPrompt"
          />
        </Text>
      </Divider>
      <ChooseDomain canUseCustomDomain={canUseCustomDomain} />
    </div>
  )
}
